export default "__VITE_ASSET__CC8u$jVW__"